'use strict';

// This is a wrapper around the import of interactjs which is currently causing
// a bug in Safari version 9 on import. https://github.com/taye/interact.js/issues/682
// A ES6 import does not allow try catch so we are reverting to require here.

try {
  var interact = require('interactjs');
}
catch (err) {
  var interact = false;
}

export default interact
